<template>
  <div class="what-we-provide-component">
    <div class="box">
      <b-tag
        type="is-accent is-uppercase has-text-weight-semibold"
        class="has-margin-bottom-15"
        >What We Provide</b-tag
      >
      <h3 class="title is-size-4 is-size-5-touch has-margin-bottom-30">
        A modern, flexible tool for collaborative video.
      </h3>
      <p class="subtitle is-size-5 is-size-6-touch">
        Create high-quality serverless synchronized video apps without the
        hassle.
      </p>
      <article
        class="media"
        v-for="feature in features"
        v-bind:key="feature.name"
      >
        <figure class="media-left">
          <p class="image is-64x64">
            <img v-bind:src="feature.imagePath" />
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p class="subtitle">
              <strong>{{ feature.name }}</strong>
              <br />
              {{ feature.description }}
            </p>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatWeProvideComponent",
  data() {
    return {
      features: [
        {
          imagePath: require("@/assets/img/icons/01.svg"),
          name: "Resources",
          description:
            "A set of open-source client libraries, documentation, and demos for fast and simple integration."
        },
        {
          imagePath: require("@/assets/img/icons/02.svg"),
          name: "Tooling",
          description:
            "A RESTful JSON API and SDK with useful methods and endpoints to cover a wide variety of use-cases."
        },
        {
          imagePath: require("@/assets/img/icons/03.svg"),
          name: "Storage",
          description:
            "We provide storage options for those who want to avoid managing a backend."
        }
      ]
    };
  }
};
</script>
